import React, { Component } from 'react'
import { FormControl } from 'react-bootstrap'


import { withTranslation } from 'react-i18next'

class TableInputDetail extends Component {
  handleChange(event) {
    this.props.updateDetailInput(event.target.value)
  }

  render() {  
    
    const { t } = this.props

    return ( 
      <FormControl
        placeholder={t("filter_menu_text_43")}
        maxLength="32"
        defaultValue={this.props.detail}
        onChange={this.handleChange.bind(this)}
      />
    )
  }
}

export default withTranslation()(TableInputDetail)